let jsonDiffPatchEntityMap = require("jsondiffpatch").create();
let jsonDiffPatchBlocks = require("jsondiffpatch").create({
    objectHash: function (obj: any) {
        return obj.key;
    },
});

export {jsonDiffPatchBlocks, jsonDiffPatchEntityMap};